import { render, staticRenderFns } from "./VideoChapter.vue?vue&type=template&id=a5c26c1a&scoped=true&"
import script from "./VideoChapter.vue?vue&type=script&lang=js&"
export * from "./VideoChapter.vue?vue&type=script&lang=js&"
import style0 from "./VideoChapter.vue?vue&type=style&index=0&id=a5c26c1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c26c1a",
  null
  
)

export default component.exports